/**
 * cookie 读写工具
 * 功能：封装 js-cookie，提供 Admin-Token 的 get/set/remove 与通用键的 get/set/remove
 */
import Cookies from "js-cookie";

const TokenKey = "Admin-Token";

/** 获取登录 token */
export function getToken() {
  return Cookies.get(TokenKey);
}

/** 写入登录 token */
export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

/** 移除登录 token */
export function removeToken() {
  return Cookies.remove(TokenKey);
}

/** 获取指定键的 cookie 值 */
export function getCookies(key) {
  return Cookies.get(key);
}

/** 写入指定键的 cookie 值 */
export function setCookies(key, value) {
  return Cookies.set(key, value);
}

/** 移除指定键的 cookie */
export function removeCookies(key) {
  return Cookies.remove(key);
}
